import type { ITask } from "./types";

/** Display label for task dropdowns: "{id} - {title}" */
export function formatTaskOptionLabel(
  task: Pick<ITask, "id" | "title">
): string {
  const title = (task.title ?? "").trim();
  if (!title) {
    return String(task.id);
  }
  return `${task.id} - ${title}`;
}
